import React from "react";

import { Provider } from "react-redux";

import store from "./store";
import MainScreen from "./Screens";

class App extends React.Component {
  render() {
    return (
      <Provider store={store}>
        <div className="container-fluid">
          <MainScreen />
        </div>
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js